import { render, staticRenderFns } from "./IconMail.vue?vue&type=template&id=2b0a6c62&scoped=true&"
import script from "./IconMail.vue?vue&type=script&lang=js&"
export * from "./IconMail.vue?vue&type=script&lang=js&"
import style0 from "./IconMail.vue?vue&type=style&index=0&id=2b0a6c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a6c62",
  null
  
)

export default component.exports